import _ from "lodash";
import { DisabledItemsData, RepoItem, ServerPermissionsData } from "../../../autogenerated/ZoomBridge";
import Authenticator from "../../../protocol/Authenticator";
import HashMap from "../../../protocol/HashMap";
import { getAssociatedAssetUIActions, getAssociatedCollectionUIActions } from "../../../util/FeatureUtil";
import { UIActions } from "../../../util/Constants";
import { OsUtil } from "../../../basic/OsUtil";
import { CM_PREDICATES } from "./predicates_CM";
import ViewUtil from "../../../ViewUtil";

const activeTab = {
  asset: 'ASSETS',
  search: 'SEARCH',
  collection: 'COLLECTIONS',
  settings: 'SETTINGS'
}

const excludedActionType = {
  ZoomAction: 'ZoomAction',
  CollectionAction: 'CollectionAction',
  ZoomSettings: 'ZoomSettings',
  MetadataProps: 'MetadataProps'
}

function getSeparatorByOptionsMap(args) {
  const sepratorByOptionsMap = new Map();
  sepratorByOptionsMap.set(UIActions.RENAME, { below: false, above: !ViewUtil.isCollectionTabActive() && true });
  sepratorByOptionsMap.set(UIActions.PURGE, { below: true, above: false });
  sepratorByOptionsMap.set(UIActions.SMART_LINK, { below: true, above: false });
  sepratorByOptionsMap.set(UIActions.ADD_TO_COLLECTION, { below: true, above: false });
  sepratorByOptionsMap.set(UIActions.VIEW_ASSET, { below: false, above: !ViewUtil.isCollectionTabActive() && true });
  sepratorByOptionsMap.set(UIActions.SHARE_AND_DOWNLOAD, { below: true, above: false });
  sepratorByOptionsMap.set(UIActions.REMOVE_FROM_FAVORITES, { below: true, above: false });
  sepratorByOptionsMap.set(UIActions.VIEW_IN_ASSET_BROWSER, { below: !ViewUtil.isCollectionTabActive() && true, above: ViewUtil.isCollectionTabActive() ? true : false });
  sepratorByOptionsMap.set(UIActions.COPY_URL, { below: CM_PREDICATES.isShowFolderDetails(args) || CM_PREDICATES.isShowArchiveDetailsOption(args), above: false });
  // sepratorByOptionsMap.set("ARCHIVE_DETAILS", { below: true, above: false });
  // sepratorByOptionsMap.set(UIActions.VIEW_IN_ASSET_BROWSER, { below: false, above: true });
  // sepratorByOptionsMap.set(UIActions.SMART_LINK, {below: CM_PREDICATES.isShowFolderDetails(args) || CM_PREDICATES.isShowArchiveDetailsOption(args), above: false})
  sepratorByOptionsMap.set(UIActions.RENAME_BIN, { below: false, above: true });
  sepratorByOptionsMap.set(UIActions.RENAME_COLLECTION, { below: false, above: true });
  sepratorByOptionsMap.set(UIActions.REMOVE_FROM_COLLECTION, { below: ViewUtil.isCollectionTabActive() && true, above: false });
  sepratorByOptionsMap.set(UIActions.DOWNLOAD, { below: ViewUtil.isCollectionTabActive() && true, above: false });
  return sepratorByOptionsMap;
}

export default class ActionUtil_CM {
  static actionUtil_CM_OBJ = null;
  constructor() {
    const serverSpec = Authenticator.getInstance().authenticationData;
    const serverPermissionsData: ServerPermissionsData = serverSpec ?
      serverSpec.serverPermissionsData : undefined;
    this.disabledItemsData = serverPermissionsData ?
      serverPermissionsData.getDisabledItemsData() : undefined;
    this.project2DisabledItems = serverPermissionsData ?
      serverPermissionsData.getProject2DisabledItems() : undefined;
    this.getSeparatorByOptionsMap = getSeparatorByOptionsMap;
  }

  static getInstance() {
    if (ActionUtil_CM.actionUtil_CM_OBJ) {
      return ActionUtil_CM.actionUtil_CM_OBJ;
    } else {
      ActionUtil_CM.actionUtil_CM_OBJ = new ActionUtil_CM();
      return ActionUtil_CM.actionUtil_CM_OBJ;
    }
  }

  /**
   * Returns a list of associated projects based on given assets.
   * @param {Array<RepoItem>} assets 
   * @returns {Array<String>}
   */
  getProjectList(assets: Array<RepoItem>): Array<String> {
    let projectList: Array<String> = [];
    if (assets && assets.length > 0) {
      for (let i = 0; i < assets.length; i++) {
        let asset = assets[i];
        if (asset && asset.getProject()) {
          projectList.push(asset.getProject());
        }
      }
    }
    return projectList;
  }

  /**
   * Give the union of all project based excluded actions.
   * @param {Array<String>} projects 
   * @param {HashMap} project2DisabledItems 
   * @returns  
   */
  getUnionOfProjectExcludedActions(projects: Array<String>, project2DisabledItems: HashMap,
    exclusionActionsType: String): Arry<String> {
    let allExcludedActions: Array<String> = [];
    if (projects && project2DisabledItems) {
      for (let i = 0; i < projects.length; i++) {
        let project = projects[i];
        let disabledItemsData = project2DisabledItems.containsKey(project) ? project2DisabledItems.get(project) : undefined;
        if (disabledItemsData) {
          switch (exclusionActionsType) {
            case excludedActionType.ZoomAction:
              allExcludedActions = _.union(allExcludedActions, disabledItemsData.getAssetActions());
              break;
            case excludedActionType.CollectionAction:
              allExcludedActions = _.union(allExcludedActions, disabledItemsData.getCollectionActions());
              break;
            case excludedActionType.ZoomSettings:
              allExcludedActions = _.union(allExcludedActions, disabledItemsData.getCollectionActions());
              break;
            default: break;
          }
        }
      }
    }
    return allExcludedActions;
  }

  /**
   * 
   * @param {Array<String>} excludedActions 
   * @param {String} exclusionActionsType 
   */
  getExcludedUIActions(excludedActions: Array<String>, exclusionActionType: String) {
    switch (exclusionActionType) {
      case excludedActionType.ZoomAction:
        let zoomActionList = []
        for (let i = 0; i < excludedActions.length; i++) {
          zoomActionList = _.union(zoomActionList, getAssociatedAssetUIActions(excludedActions[i]));
        }
        return zoomActionList;
      case excludedActionType.CollectionAction:
        let collectionActionList = []
        for (let i = 0; i < excludedActions.length; i++) {
          collectionActionList = _.union(collectionActionList, getAssociatedCollectionUIActions(excludedActions[i]));
        }
        return collectionActionList;
      case excludedActionType.ZoomSettings:
        return excludedActions;
      case excludedActionType.MetadataProps:
        return excludedActions;
      default:
        return excludedActions;
    }
  }

  getExcludedActions(assets: Array<RepoItem>) {
    let excludedActions = [];
    if (assets && assets.length && (this.disabledItemsData || this.project2DisabledItems)) {
      const disabledItemsData: DisabledItemsData = this.disabledItemsData;
      const project2DisabledItems: HashMap = this.project2DisabledItems;
      const projects: Array<RepoItem> = this.getProjectList(assets);
      const actions = { rootExcludedActions: null, projectExcludedActions: null }
      switch (window.ARGS.activeTab) {
        case activeTab.search:
        case activeTab.asset: actions.rootExcludedActions = disabledItemsData ? disabledItemsData.getAssetActions() : [];
          actions.projectExcludedActions = this.getUnionOfProjectExcludedActions(projects, project2DisabledItems, excludedActionType.ZoomAction);
          break;
        case activeTab.collection: actions.rootExcludedActions = disabledItemsData ? disabledItemsData.getCollectionActions() : [];
          actions.projectExcludedActions = this.getUnionOfProjectExcludedActions(projects, project2DisabledItems, excludedActionType.CollectionAction);
          break;
        case activeTab.settings: actions.rootExcludedActions = disabledItemsData ? disabledItemsData.getCollectionActions() : [];
          actions.projectExcludedActions = this.getUnionOfProjectExcludedActions(projects, project2DisabledItems, excludedActionType.ZoomSettings);
          break;
        default: break;
      }
      excludedActions = this.getExcludedUIActions(_.union(actions.rootExcludedActions, actions.projectExcludedActions), excludedActionType.ZoomAction);
    }
    return excludedActions;
  }

  getFinalActionList(actionKeys: Array<String | Object>, excludedActionList: Array<String>) {
    if (actionKeys && actionKeys.length) {
      let excludedItems = [];
      for (const actionKey of actionKeys) {
        let keepActionKey = false;
        if (typeof actionKey === 'object' && excludedActionList.indexOf(actionKey.key) < 0) {
          let values = actionKey.value;
          values = this.getFinalActionList(values, excludedActionList);
          keepActionKey = values && values.length > 0;
        }
        else {
          keepActionKey = excludedActionList.indexOf(actionKey) < 0;
        }
        if (!keepActionKey) {
          excludedItems.push(actionKey);
        }
      }
      actionKeys = _.difference(actionKeys, excludedItems);
    }
    return actionKeys;
  }
}